import {
  Autocomplete,
  Button,
  Grid,
  InputAdornment,
  Paper,
  Snackbar,
  Alert,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import React, { useEffect, useState } from "react";
import CreateSequence from "../Modal/CreateSequence";
import SequenceFilterItems from "./SequenceFilterItems";
import "./SequenceFilters.css";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../../features/userSlice";
import { useLocation, useSearchParams } from "react-router-dom";
import { CheckPermissions } from "../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

interface ChainsFiltersProps {
  updatedArray: any;
  etlSequence: any;
  processList: any;
  setPage: any;
  oauthTokenHeader: any;
  selectedRowData: any;
  setSelectedRowData: any;
  selected: any;
  setSelected: any;
  setEtlSequence: any;
  rowId: any;
  setRowId: any;
  status: any;
  setStatus: any;
  selectedChain: string;
  isEditBtnEnabled: any;
  setIsEditBtnEnabled: any;
  setSelectedChain: React.Dispatch<React.SetStateAction<string>>;
  setReload: any;
  filteredDataSequence: any;
  selectedStatuses: any;
  setSelectedStatuses: any;
  selectedLastRunDate: any;
  setSelectedLastRunDate: any;
  selectedFrequencyDate: any;
  setSelectedFrequencyDate: any;
}

const SequenceFilters = ({
  updatedArray,
  etlSequence,
  processList,
  setPage,
  oauthTokenHeader,
  setEtlSequence,
  status,
  setStatus,
  selectedChain,
  setSelectedChain,
  setReload,
  filteredDataSequence,
  selectedStatuses,
  setSelectedStatuses,
  selectedLastRunDate,
  setSelectedLastRunDate,
  selectedFrequencyDate,
  setSelectedFrequencyDate,
}: ChainsFiltersProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [loading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const response = useSelector(selectUserData);
  const [searchParam, setSearchParam] = useSearchParams();
  const location = useLocation();
  const hasEtlSequencesCreatePermission = CheckPermissions(
    response?.data?.products?.admin,
    "processes",
    "create_etl_sequences"
  );
  const [snackbarMessage] = useState("");

  const tableFilterProps = {
    etlSequence,
    updatedArray,
    setPage,
    status,
    setStatus,
    selectedChain,
    setSelectedChain,
    filteredDataSequence,
    selectedStatuses,
    setSelectedStatuses,
    selectedFrequencyDate,
    setSelectedFrequencyDate,
    selectedLastRunDate,
    setSelectedLastRunDate,
  };

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const renderSnackbar = () => {
    return (
      <Snackbar
        sx={{ zIndex: "9999999" }}
        open={snackbarOpen}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    );
  };
  const sequenceData = etlSequence?.data?.map(
    (sequence: any) => sequence?.name
  );

  useEffect(() => {
    const searchValue = searchParam.get("search");
    if (searchValue) {
      setSelectedChain(searchValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam]);

  return (
    <>
      {renderSnackbar()}
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Paper className="chainsFiltersWrap">
          <div style={{ padding: "16px" }}>
            {/* Heading */}
            <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
              <Grid item xs={8}>
                <Typography variant="h3" sx={{ fontSize: "24px" }}>
                  ETL Sequences
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Manage sequence settings or add new sequences.
                </Typography>
              </Grid>
            </Grid>
            {/* Filter part */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginTop: "5px",
                }}
              >
                {/*Queue Name */}
                <Autocomplete
                  data-tracker="214"
                  options={sequenceData ? sequenceData : []}
                  value={selectedChain}
                  onChange={(_, newValue: any) => {
                    setSelectedChain(newValue); // Update state with selected sequence
                    setPage(0); // Reset page number to 0
                    const updatedParams = new URLSearchParams(location.search);
                    if (newValue) {
                      updatedParams.set("search", newValue);
                      updatedParams.set("page", "0"); // Set the new value in search params
                    } else {
                      updatedParams.delete("search"); // Remove if no value is selected
                    }

                    setSearchParam(updatedParams);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Sequence Name"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon sx={{ marginLeft: "12px" }} />
                          </InputAdornment>
                        ),
                      }}
                      color="secondary"
                    />
                  )}
                  size="small"
                  sx={{ width: "300px" }}
                />
                <SequenceFilterItems {...tableFilterProps} />
              </div>
              {/* Action Buttons */}
              <div style={{ display: "flex", alignItems: "center" }}>
                {hasEtlSequencesCreatePermission ? (
                  <Button
                    data-tracker="218"
                    variant="contained"
                    color="secondary"
                    endIcon={<AddIcon />}
                    onClick={handleOpen}
                  >
                    Create New Sequence
                  </Button>
                ) : (
                  <Button variant="contained" endIcon={<AddIcon />} disabled>
                    {" "}
                    Create New Sequence
                  </Button>
                )}
                <CreateSequence
                  etlSequence={etlSequence}
                  processList={processList}
                  oauthTokenHeader={oauthTokenHeader}
                  setEtlSequence={setEtlSequence}
                  openModal={openModal}
                  onCloseModal={handleClose}
                  setReload={setReload}
                />
              </div>
            </div>
          </div>
        </Paper>
      )}
    </>
  );
};
export default SequenceFilters;
